import cn from 'classnames';
import {
  RUBRIC_SAMPLE,
  RUBRIC_TOTAL,
  RUBRIC_TOTALS,
  RubricCriterion,
  RubricTier,
  TINUITI_WAY_SOURCES
} from './planning-rubric';

// Human-skill-as-code: the standard every plan is held to. The planner silently
// self-reviews each plan against this encoded rubric before finalizing — the
// rubric codifies Tinuiti's senior-planner judgment (the Tinuiti Way).
// Shown next to the decision trail: the trail is what the agent decided for THIS
// plan; the rubric is the standing standard it had to meet.
export const PlanningRubricPanel = () => (
  <div className='elevate-rubric'>
    <div className='elevate-rubric-head'>
      <h2 className='elevate-rubric-title'>The standard every plan is held to</h2>
      <p className='elevate-rubric-sub'>
        Before finalizing, the planner silently self-reviews the plan against{' '}
        <strong>{RUBRIC_TOTAL} encoded criteria</strong> ({RUBRIC_TOTALS.mechanical} mechanical,{' '}
        {RUBRIC_TOTALS.quality} quality) — grounded in the Tinuiti Way and codified senior-planner
        judgment. Human expertise encoded as code, holding every machine-generated plan to the
        standard an expert would demand — not an algorithm minimizing a cost function. A
        representative sample:
      </p>
    </div>
    <div className='elevate-rubric-list'>
      {RUBRIC_SAMPLE.map(c => (
        <RubricRow key={c.id} criterion={c} />
      ))}
    </div>
    <p className='elevate-rubric-source'>
      Grounded in the Tinuiti Way: {TINUITI_WAY_SOURCES.join(' · ')}.
    </p>
  </div>
);

interface RubricRowProps {
  criterion: RubricCriterion;
}

const RubricRow = ({ criterion }: RubricRowProps) => (
  <div className={cn('elevate-rubric-item', { 'is-capstone': criterion.capstone })}>
    <div className='elevate-rubric-item-head'>
      <span className='elevate-rubric-id elevate-rubric-mono'>{criterion.id}</span>
      <span className='elevate-rubric-name'>{criterion.title}</span>
      <span
        className={cn('elevate-rubric-tier', {
          'is-quality': criterion.tier === RubricTier.QUALITY
        })}
      >
        {criterion.tier}
      </span>
      {criterion.capstone ? (
        <span className='elevate-rubric-capstone-tag'>capstone</span>
      ) : undefined}
    </div>
    <p className='elevate-rubric-check'>{criterion.check}</p>
    <p className='elevate-rubric-provenance'>{criterion.source}</p>
  </div>
);
